<template>
  <click-outside :do="close">
    <div class="relative">
      <transition name="fade">
        <div v-if="isVisible" class="backdrop" @click="close"></div>
      </transition>
      <transition name="scale">
        <div v-if="isVisible" class="modal fixed max-w-sm mx-auto w-full shadow-lg font-normal z-50 px-2">
          <!-- header -->
          <div class="bg-primary flex justify-between items-center text-white">
            <p class="p-3">New Help Request</p>
            <span @click="close" class="icon-close_icon-1 p-3 text-sm font-helvetica font-light cursor-pointer"></span>
          </div>
          <!-- content -->
          <div class="bg-white px-5 py-3">
            <p class="text-xs text-grey-darkest font-bold mb-1">What kind of support are you looking for?</p>
            <select
              class="select-css block text-sm rounded-none border-1 border-grey w-full p-1 mb-4"
              @change="onSelectType($event)"
            >
              <option disabled>Select an Option</option>
              <option v-for="type in helpTypes" :key="type.id" :value="type.id" :title="type.description">
                {{ type.title }}
              </option>
            </select>

            <select
              class="select-css block text-sm rounded-none border-1 border-grey w-full p-1"
              @change="onSelectSubject($event)"
            >
              <option disabled>Select an Option</option>
              <option v-for="type in subjects" :key="type.id" :value="type.id">{{ type.title }}</option>
            </select>

            <p class="text-xs text-grey-darkest font-bold mb-1 mt-5">Please describe your issue or question below</p>
            <textarea
              v-model="comment"
              class="w-full border-1 p-2 text-xs mb-2"
              placeholder="Type text here..."
              rows="4"
            ></textarea>
          </div>
          <!-- footer -->
          <div class="bg-white flex justify-end items-center p-3 border-t-1 border-grey">
            <button-module
              small
              class="text-4xs font-bold py-2 px-4 mr-2"
              :disabled="disabledSendRequest"
              @click="sendRequest"
              >{{ $t('Send Help Request') }}</button-module
            >
            <button-module small reversed class="text-4xs font-bold py-2 px-4" @click="close">{{
              $t('Cancel')
            }}</button-module>
          </div>
        </div>
      </transition>
    </div>
  </click-outside>
</template>

<script>
import { preventBodyScroll } from '@/core/helper-functions'
import { useGeneralStore } from '@/stores/general'
import ClickOutside from '@/components/shared/ClickOutside'
import generalService from '@/services/general.service'
import ButtonModule from '@/components/shared/ButtonModule'

export default {
  components: { ClickOutside, ButtonModule },

  setup () {
    const generalStore = useGeneralStore()

    return {
      generalStore
    }
  },

  props: ['isVisible'],

  data () {
    return {
      helpTypes: [],
      subjects: [],
      selectedType: null,
      selectedSubject: null,
      comment: ''
    }
  },

  computed: {
    isMobile () {
      return this.generalStore.isMobile
    },
    disabledSendRequest () {
      return !this.selectedType || !this.selectedSubject || this.comment.trim() === ''
    }
  },

  methods: {
    close () {
      this.helpTypes = []
      this.subjects = []
      this.selectedType = null
      this.selectedSubject = null
      this.comment = ''
      this.$emit('close')
    },

    onSelectType (event) {
      this.selectedType = event.target.value
      this.selectedSubject = null
      event.target.value ? this.getHelpTypesSubjects(event.target.value) : (this.subjects = [])
    },

    onSelectSubject (event) {
      this.selectedSubject = event.target.value
    },

    getHelpTypes () {
      generalService
        .getHelpTypes()
        .then(({ data }) => {
          this.helpTypes = data
          if (data.length) {
            this.selectedType = data[0].id
            this.getHelpTypesSubjects(data[0].id)
          }
        })
        .catch(err => Promise.reject(err))
    },

    getHelpTypesSubjects (value) {
      generalService
        .getHelpTypesSubjects(value)
        .then(({ data }) => {
          this.subjects = data
          if (data.lenght !== 0) this.selectedSubject = data[0].id
        })
        .catch(err => Promise.reject(err))
    },

    sendRequest () {
      generalService
        .sendRequest({ type_id: this.selectedType, subject_id: this.selectedSubject, comment: this.comment })
        .then(({ data }) => {
          this.$notify({ title: 'Success', message: data.message, type: 'success', position: 'bottom-right' })
          this.close()
        })
        .catch(err => Promise.reject(err))
    }
  },

  watch: {
    isVisible (value) {
      if (value) this.getHelpTypes()
      if (this.isMobile) {
        preventBodyScroll(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.select-css {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 10px top 50%, 0 0;
  background-size: 10px auto, 100%;
}
.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #888;
}
.select-css:focus {
  outline: none;
}
.select-css option {
  font-weight: normal;
}
</style>
